import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import PREFIX from '../prefix';
import { $el, getNumTypeAttr, getStrTypeAttr, removeAttrs, setText } from '../../dom-utils';
import 'dayjs/locale/zh-cn';
var Time = /** @class */ (function () {
    function Time() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-time', { all: true });
        // 配置默认语言 (全局)
        dayjs.locale('zh-cn');
        // 改变语言配置 (全局)，需自行引入 dayjs 语言包
        // 注意！通过 script 标签引入 rabbitjs 的情况下，通过这个函数设置语言是无效的
        this.locale = function (str) { return dayjs.locale(str); };
        this._create(this.COMPONENTS);
    }
    Time.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), type = _a.type, time = _a.time, interval = _a.interval, hash = _a.hash;
            _this._setTime(node, type, time, interval);
            _this._handleClick(node, hash);
            removeAttrs(node, ['time', 'type', 'hash', 'interval']);
        });
    };
    Time.prototype._setTime = function (node, type, time, interval) {
        var timeStamp = eval(time);
        var seconds = 0;
        var timer = function () {
            if (type === 'relative') {
                dayjs.extend(relativeTime);
                var _relativeTime = dayjs(timeStamp).fromNow();
                // 如果自动更新的间隔小于60则是要通过秒更新时间而不是分钟
                // 当秒数走到60秒后就转换为 “x分钟前” 显示
                if (interval < 60) {
                    var Chinese = ['zh', 'zh-cn', 'zh-hk', 'zh-tw'];
                    // 语言环境为中文才进行并显示秒级别更新
                    if (Chinese.includes(dayjs.locale())) {
                        seconds++;
                        setText(node, seconds + "\u79D2\u524D");
                    }
                }
                else {
                    setText(node, _relativeTime);
                }
                // 这段为设置中文状态下的情景
                if (_relativeTime === '几秒前') {
                    _relativeTime = '刚刚';
                }
                else {
                    setText(node, _relativeTime);
                }
            }
            else if (type === 'date') {
                var date = dayjs(timeStamp).format('YYYY-MM-DD');
                setText(node, date);
            }
            else if (type === 'datetime') {
                var dataTime = dayjs(timeStamp).format('YYYY-MM-DD-HH:mm:ss');
                setText(node, dataTime);
            }
            return timer;
        };
        setTimeout(function () {
            window.setInterval(timer(), interval * 1000);
        }, 0);
    };
    Time.prototype._handleClick = function (node, hash) {
        if (!hash)
            return;
        node.classList.add(PREFIX.time + "-with-hash");
        node.addEventListener('click', function () { return (window.location.hash = hash); });
    };
    Time.prototype._attrs = function (node) {
        return {
            time: getStrTypeAttr(node, 'time', ''),
            type: getStrTypeAttr(node, 'type', 'relative'),
            hash: getStrTypeAttr(node, 'hash', ''),
            interval: getNumTypeAttr(node, 'interval', 60)
        };
    };
    return Time;
}());
export default Time;
